<template>
  <section
    v-if="getAttributesActive"
    class="attribute-listing-filters"
  >
    <div class="attribute-listing-filters-wrapper">
      <BaseGroupListingFilters
        v-if="getListingAttributeGroupCombos.length > 0"
        :base-group-combos="getListingAttributeGroupCombos"
      >
      </BaseGroupListingFilters>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseGroupListingFilters from '../Components/BaseGroupListingFilters'

export default {
  name: 'AttributeListingFilters',
  props: [],
  components: {
    BaseGroupListingFilters
  },
  computed: {
    ...mapGetters([
      'getListingAttributeGroupCombos',
      'getAttributesActive',
      'getUriWithoutOffset',
      'getIsTopLevelCategory',
      'getActiveAttributeFilters',
      'config'
    ]),
    urlNoFilters () {
      const url = '/' + this.config.url.lang + this.getUriWithoutOffset
      if (this.getIsTopLevelCategory) {
        return url + '/1'
      }
      return url
    }
  }
}
</script>
